import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import { IconButton, Tooltip } from '@mui/material';

type InterruptionCreateButtonProps = {
  ariaLabel?: string;
  onClick: () => void;
  title?: string;
};

const BUTTON_SX = {
  width: 36,
  height: 36,
  border: '1px solid',
  borderColor: 'primary.main',
  borderRadius: '50%',
  color: 'primary.main',
} as const;

const InterruptionCreateButton = ({
  ariaLabel = 'Create interruption',
  onClick,
  title = 'Request callback',
}: InterruptionCreateButtonProps) => (
  <Tooltip title={title}>
    <IconButton aria-label={ariaLabel} sx={BUTTON_SX} onClick={onClick}>
      <LocalPhoneOutlinedIcon fontSize="small" />
    </IconButton>
  </Tooltip>
);

export default InterruptionCreateButton;
